// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6288":"67b5170b","8708":"49622082"}[chunkId] + ".chunk.css";
};